import React, {useMemo} from 'react';
import {Menu, MenuItem} from '@mui/material';
import {GridSortModel} from '@mui/x-data-grid';
import {SortDirection} from '../../../types/types';
import {t} from 'i18next';

interface AurCustomSortProps {
  anchorEl: null | HTMLElement;
  onClose: () => void;
  onSort: (direction: SortDirection) => void;
  sortModel: GridSortModel | undefined;
  activeColumn: string | null;
  ascFieldName?: string;
  descFieldName?: string;
}

const AurCustomSort: React.FC<AurCustomSortProps> = ({
  anchorEl,
  onClose,
  onSort,
  sortModel,
  activeColumn,
  ascFieldName,
  descFieldName,
}) => {
  const open = Boolean(anchorEl);

  const setSelectedColumnAndSortOption = useMemo(
    () => (sort: string) =>
      sortModel?.[0]?.sort === sort && sortModel[0]?.field === activeColumn,
    [sortModel, activeColumn]
  );

  const handleSortAscending = () => {
    onSort('asc');
  };

  const handleSortDescending = () => {
    onSort('desc');
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      aria-haspopup="menu"
      aria-expanded={open}
      disableScrollLock
    >
      <MenuItem
        selected={setSelectedColumnAndSortOption('asc')}
        onClick={handleSortAscending}
      >
        {ascFieldName ? ascFieldName : t('sort.ascending')}
      </MenuItem>
      <MenuItem
        selected={setSelectedColumnAndSortOption('desc')}
        onClick={handleSortDescending}
      >
        {descFieldName ? descFieldName : t('sort.descending')}
      </MenuItem>
    </Menu>
  );
};

export default AurCustomSort;
